import { MutationTree } from "vuex";
import { ExecYearmonthState, SET_EXEC_YEARMONTH } from "./types";

export const mutations: MutationTree<ExecYearmonthState> = {
  [SET_EXEC_YEARMONTH](state, exec_yearmonth: string) {
    state.exec_yearmonth = exec_yearmonth;
  }
};
